import * as googleDocs from './normalizers/googleDocs';
import * as msWord from './normalizers/msWord';

const normalizers = [msWord, googleDocs];

const normalizeExternalHTML = (html?: string | null) => {
  if (html) {
    const enabledNormalizer = normalizers.find(({ shouldEnable }) =>
      shouldEnable(html),
    );

    if (enabledNormalizer) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (doc.documentElement) {
        enabledNormalizer.normalize(doc);
        return doc.documentElement.outerHTML;
      }
    }
  }

  return html;
};

export default normalizeExternalHTML;
